import { baseApi, type MoneyDto } from '@shared/api/baseApi';

export type FlashDrawStatus =
  | 'UPCOMING'
  | 'LIVE'
  | 'FULL'
  | 'DRAWING'
  | 'COMPLETED'
  | 'CANCELLED';

export interface FlashDrawDto {
  id: string;
  status: FlashDrawStatus;
  entryPrice: MoneyDto;
  participantLimit: number;
  participantCount: number;
  userJoined: boolean;
  startsAt: string;
  endsAt: string;
  fullAt: string | null;
  drawAt: string | null;
  drawnAt: string | null;
  cancellationReason: string | null;
  winnerName: string | null;
  product: { id: string; name: string; logoUrl: string };
}

export interface FlashDrawResponse {
  serverTime: string;
  clientReceivedAt: number;
  draw: FlashDrawDto | null;
}

export const flashDrawApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFlashDraw: builder.query<FlashDrawResponse, void>({
      query: () => '/flash-draw',
      transformResponse: (response: Omit<FlashDrawResponse, 'clientReceivedAt'>) => ({
        ...response,
        clientReceivedAt: Date.now(),
      }),
      providesTags: ['FlashDraw'],
    }),
    joinFlashDraw: builder.mutation<
      {
        participantCount: number;
        participantLimit: number;
        status: FlashDrawStatus;
        userJoined: true;
        newBalance: MoneyDto;
      },
      string
    >({
      query: (id) => ({ url: `/flash-draws/${id}/join`, method: 'POST' }),
      invalidatesTags: ['FlashDraw', 'AdminFlashDraw', 'User', 'AdminAnalytics'],
    }),
  }),
});

export const { useGetFlashDrawQuery, useJoinFlashDrawMutation } = flashDrawApi;
